module.exports = __webpack_public_path__ + "static/media/Visualisation.ef906ec7.mp3";